/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BusinessAddressDto } from './BusinessAddressDto';
import {
    BusinessAddressDtoFromJSON,
    BusinessAddressDtoFromJSONTyped,
    BusinessAddressDtoToJSON,
    BusinessAddressDtoToJSONTyped,
} from './BusinessAddressDto';
import type { PrimaryContactDto } from './PrimaryContactDto';
import {
    PrimaryContactDtoFromJSON,
    PrimaryContactDtoFromJSONTyped,
    PrimaryContactDtoToJSON,
    PrimaryContactDtoToJSONTyped,
} from './PrimaryContactDto';

/**
 * 
 * @export
 * @interface CustomerDto
 */
export interface CustomerDto {
    /**
     * 
     * @type {boolean}
     * @memberof CustomerDto
     */
    _protected?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CustomerDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerDto
     */
    companyName?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerDto
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerDto
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerDto
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerDto
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerDto
     */
    industryType?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerDto
     */
    timezone?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerDto
     */
    language?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerDto
     */
    currency?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerDto
     */
    companySize?: string;
    /**
     * 
     * @type {BusinessAddressDto}
     * @memberof CustomerDto
     */
    businessAddress?: BusinessAddressDto;
    /**
     * 
     * @type {PrimaryContactDto}
     * @memberof CustomerDto
     */
    primaryContact?: PrimaryContactDto;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CustomerDto
     */
    settings?: { [key: string]: any; };
    /**
     * 
     * @type {Date}
     * @memberof CustomerDto
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CustomerDto
     */
    updatedAt?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerDto
     */
    isProtected?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CustomerDto
     */
    tenantId?: string;
}

/**
 * Check if a given object implements the CustomerDto interface.
 */
export function instanceOfCustomerDto(value: object): value is CustomerDto {
    return true;
}

export function CustomerDtoFromJSON(json: any): CustomerDto {
    return CustomerDtoFromJSONTyped(json, false);
}

export function CustomerDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomerDto {
    if (json == null) {
        return json;
    }
    return {
        
        '_protected': json['protected'] == null ? undefined : json['protected'],
        'id': json['id'] == null ? undefined : json['id'],
        'companyName': json['company_name'] == null ? undefined : json['company_name'],
        'displayName': json['display_name'] == null ? undefined : json['display_name'],
        'slug': json['slug'] == null ? undefined : json['slug'],
        'email': json['email'] == null ? undefined : json['email'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'industryType': json['industry_type'] == null ? undefined : json['industry_type'],
        'timezone': json['timezone'] == null ? undefined : json['timezone'],
        'language': json['language'] == null ? undefined : json['language'],
        'currency': json['currency'] == null ? undefined : json['currency'],
        'companySize': json['company_size'] == null ? undefined : json['company_size'],
        'businessAddress': json['business_address'] == null ? undefined : BusinessAddressDtoFromJSON(json['business_address']),
        'primaryContact': json['primary_contact'] == null ? undefined : PrimaryContactDtoFromJSON(json['primary_contact']),
        'settings': json['settings'] == null ? undefined : json['settings'],
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'updatedAt': json['updated_at'] == null ? undefined : (new Date(json['updated_at'])),
        'isProtected': json['is_protected'] == null ? undefined : json['is_protected'],
        'tenantId': json['tenant_id'] == null ? undefined : json['tenant_id'],
    };
}

export function CustomerDtoToJSON(json: any): CustomerDto {
    return CustomerDtoToJSONTyped(json, false);
}

export function CustomerDtoToJSONTyped(value?: CustomerDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'protected': value['_protected'],
        'id': value['id'],
        'company_name': value['companyName'],
        'display_name': value['displayName'],
        'slug': value['slug'],
        'email': value['email'],
        'phone': value['phone'],
        'industry_type': value['industryType'],
        'timezone': value['timezone'],
        'language': value['language'],
        'currency': value['currency'],
        'company_size': value['companySize'],
        'business_address': BusinessAddressDtoToJSON(value['businessAddress']),
        'primary_contact': PrimaryContactDtoToJSON(value['primaryContact']),
        'settings': value['settings'],
        'created_at': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updated_at': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
        'is_protected': value['isProtected'],
        'tenant_id': value['tenantId'],
    };
}

